<template>
  <!-- Figma D1–D6 component card: tinted card, 34px strip with a status dot + name; red = critical, yellow = needs attention -->
  <div class="rounded-[5px] border-1 p-[5px] pb-[15px] font-roboto"
    :class="critical ? 'bg-[#FEEFEE4D] border-[#FEEFEE]' : 'bg-[#FDF4E14D] border-[#FDF4E1]'">
    <div class="flex items-center justify-between gap-[12px] min-h-[34px] px-[10px] py-[6px] rounded-[5px]"
      :class="critical ? 'bg-[#EE58511A]' : 'bg-[#F3C86933]'">
      <span class="flex items-center gap-[12px] min-w-0">
        <span class="w-[18px] h-[18px] rounded-full flex items-center justify-center flex-shrink-0"
          :class="critical ? 'bg-[#EE5851]' : 'bg-[#F5B301]'">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 64 64">
            <path d="M0 0h64v64H0z" fill="none" />
            <path fill="#fff" d="M56 2L18.8 42.909L8 34.729H2L18.8 62L62 2z" />
          </svg>

        </span>
        <span class="text-[16px] font-medium text-[#333333] break-words">{{ title }}</span>
      </span>
      <slot name="actions" />
    </div>
    <div class="px-[10px] pt-[10px]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    // diagnosis value: 3 = critical (red), 2 = needs attention (yellow)
    value: { type: [Number, String], default: 2 },
  },
  computed: {
    critical() {
      return Number(this.value) === 3;
    },
  },
};
</script>
